import {
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Switch,
  Table,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import FileDownloadIcon from "@material-ui/icons/GetApp";
import React, { useState } from "react";
import PaginationTable from "../../paginationTable";
import { CouponBatch, CouponTypes } from "../../../../types/coupons";
import { getCouponStatus } from "../../../../helpers/getCouponStatus";
import { getDate } from "../../../../helpers/dateHelper";
import HeadTable from "../../sortTable/sortTable";
import TablesSearch from "../../tablesSearch/tablesSearch";
import CheckBoxesFilter from "../../checkboxFilter";
import DateFilter from "../../../users/DateFilter";
import { FilterDate } from "../../../../types/commonForm";

import "./couponsBatchTableStyles.css";

interface Props {
  coupons: Array<CouponBatch>;
  tableComponentScope: "general" | "userMenengment";
  handleChangeCouponStatus?: (couponId: string | undefined) => void;
  page: number;
  perPage: number;
  collectionLength: number;
  total: number;
  isView: boolean;
  handleShowViewModal: (couponId: string | undefined) => void;
  handleShowDeleteModal: (couponId: string | undefined) => void;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => void;
  handleLastPage: () => void;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleFirstPage: () => void;
  handleSort: (direction: string, title: string) => void;
  applySearch: (field: string) => void;
  typeFilterValues: any;
  statusFilterValues: any;
  checkTypesFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkStatusFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
  applyStatusFilter: () => void;
  applyTypeFilter: () => void;
  clearTypeFilter: () => void;
  clearStatusFilter: () => void;
  startDate: FilterDate;
  finishDate: FilterDate;
  setStartStartDate: (value: Date) => void;
  setStartEndDate: (value: Date) => void;
  setEndStartDate: (value: Date) => void;
  setEndEndDate: (value: Date) => void;
  applyDateFilter: () => void;
  clearStartDateFilter: () => void;
  clearEndDateFilter: () => void;
  search: (value: string, field: string) => void;
  clearSearch: (field: string) => void;
  searchValue: string;
  handleDownloadBatchFile: (couponId: string | undefined, couponTitle: string | undefined) => void;
}
export const CouponsBatchTable = ({
  coupons,
  page,
  perPage,
  collectionLength,
  total,
  tableComponentScope,
  handleShowViewModal,
  handleChangeCouponStatus,
  handleChangePage,
  handleLastPage,
  handleChangeRowsPerPage,
  handleFirstPage,
  handleShowDeleteModal,
  isView,
  handleSort,
  applySearch,
  typeFilterValues,
  statusFilterValues,
  checkTypesFilter,
  checkStatusFilter,
  applyStatusFilter,
  applyTypeFilter,
  clearTypeFilter,
  clearStatusFilter,
  startDate,
  finishDate,
  setStartStartDate,
  setStartEndDate,
  setEndStartDate,
  setEndEndDate,
  clearStartDateFilter,
  applyDateFilter,
  clearEndDateFilter,
  search,
  clearSearch,
  searchValue,
  handleDownloadBatchFile,
}: Props) => {
  const [dropdown, setDropdown] = useState({
    couponId: false,
    type: false,
    status: false,
    start: false,
    finish: false,
  });

  const filterDropdown = (title: string) => {
    setDropdown({ ...dropdown, [title]: !dropdown[title] });
  };

  const closeFilter = () => {
    setDropdown({
      couponId: false,
      type: false,
      status: false,
      start: false,
      finish: false,
    });
  };

  return (
    <>
      <TableContainer className="couponTableWrapper">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell key={1}>
                <HeadTable
                  title="#"
                  sort={(direction, field) => handleSort(direction, "couponId")}
                  filterHandle={() => filterDropdown("couponId")}
                />
                {dropdown.couponId && (
                  <TablesSearch
                    search={(event) =>
                      search(event.currentTarget.value, "couponId")
                    }
                    applySearch={() => applySearch("couponId")}
                    searchString={searchValue}
                    clearSearch={() => clearSearch("couponId")}
                  />
                )}
              </TableCell>
              {tableComponentScope === "general" ? (
                <TableCell>
                  <HeadTable
                    title="Type"
                    sort={(direction, field) => handleSort(direction, "type")}
                    filterHandle={() => filterDropdown("type")}
                  />
                  {dropdown.type && (
                    <CheckBoxesFilter
                      names={[
                        CouponTypes.Basket,
                        CouponTypes.DreamHome,
                        CouponTypes.SubscriptionBasket,
                        // CouponTypes.SingleSubscription,
                        // CouponTypes.SingleOrder,
                      ]}
                      applyFilter={applyTypeFilter}
                      clearSelectedItem={clearTypeFilter}
                      filterValues={typeFilterValues}
                      checkFilter={checkTypesFilter}
                    />
                  )}
                </TableCell>
              ) : null}
              <TableCell>
                {tableComponentScope === "general" ? (
                  <>
                    <HeadTable
                      title={"Start Date"}
                      sort={(direction, field) =>
                        handleSort(direction, "startDate")
                      }
                      filterHandle={() => filterDropdown("start")}
                    />
                    {dropdown.start && (
                      <DateFilter
                        applyDateFilter={applyDateFilter}
                        clearDateFilter={clearStartDateFilter}
                        endDate={startDate.endDate}
                        startDate={startDate.startDate}
                        setStartDate={setStartStartDate}
                        setEndDate={setStartEndDate}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <HeadTable
                      title="Date"
                      sort={(direction, field) =>
                        handleSort(direction, "dateOfUse")
                      }
                    />
                  </>
                )}
              </TableCell>
              {tableComponentScope === "general" ? (
                <TableCell>
                  <HeadTable
                    title="Finish Date"
                    sort={(direction, field) =>
                      handleSort(direction, "finishDate")
                    }
                    filterHandle={() => filterDropdown("finish")}
                  />
                  {dropdown.finish && (
                    <DateFilter
                      applyDateFilter={applyDateFilter}
                      clearDateFilter={clearEndDateFilter}
                      endDate={finishDate.endDate}
                      startDate={finishDate.startDate}
                      setStartDate={setEndStartDate}
                      setEndDate={setEndEndDate}
                    />
                  )}
                </TableCell>
              ) : (
                <TableCell>Description</TableCell>
              )}
              <TableCell>Num of Coupons</TableCell>
              {tableComponentScope === "general" && (
                <TableCell className="status-column">
                  <HeadTable
                    title="Active"
                    sort={(direction, field) => handleSort(direction, "status")}
                    filterHandle={() => filterDropdown("status")}
                  />
                  {dropdown.status && (
                    <CheckBoxesFilter
                      names={["Active", "Inactive"]}
                      applyFilter={applyStatusFilter}
                      clearSelectedItem={clearStatusFilter}
                      filterValues={statusFilterValues}
                      checkFilter={checkStatusFilter}
                    />
                  )}
                </TableCell>
              )}
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody onClick={closeFilter}>
            {coupons.length > 0 &&
              coupons.map((coupon) => {
                let couponStatus = getCouponStatus(coupon);
                return (
                  <TableRow key={coupon._id}>
                    <TableCell>{coupon.couponId}</TableCell>
                    {tableComponentScope === "general" ? (
                      <TableCell>{coupon.type}</TableCell>
                    ) : null}
                    <TableCell>
                      {coupon.startDate
                        ? getDate(new Date(coupon.startDate))
                        : "---"}
                    </TableCell>
                    {tableComponentScope === "general" ? (
                      <TableCell>
                        {coupon.finishDate
                          ? getDate(new Date(coupon.finishDate))
                          : "---"}
                      </TableCell>
                    ) : (
                      <TableCell>
                        <div className="descriptionCell">
                          {coupon.description
                            ? `${coupon.description.slice(0, 15)}...`
                            : "---"}
                        </div>
                      </TableCell>
                    )}
                    <TableCell>{coupon.limit}</TableCell>
                    {tableComponentScope === "general" && (
                      <TableCell>
                        {couponStatus.type === "string" ? (
                          `${couponStatus.value}`
                        ) : (
                          <Switch
                            checked={coupon.isActive}
                            onChange={() =>
                              handleChangeCouponStatus!(coupon._id)
                            }
                            color="primary"
                            name="isActive"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        )}
                      </TableCell>
                    )}
                    <TableCell className="actions-table-cell">
                      <div className="actions-table-body">
                        <VisibilityIcon
                          onClick={() => handleShowViewModal(coupon._id)}
                          id="show-tickets"
                        />
                        <FileDownloadIcon
                          onClick={() => handleDownloadBatchFile(coupon._id, coupon.couponId)}
                          id="download-file"
                        />

                        {!isView && (
                          <div
                            onClick={() => handleShowDeleteModal(coupon._id)}
                          >
                            <DeleteForeverIcon className="delete-icon" />
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <PaginationTable
        page={page}
        perPage={perPage}
        collectionLength={collectionLength}
        total={total}
        handleChangePage={handleChangePage}
        handleLastPage={handleLastPage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleFirstPage={handleFirstPage}
        title="Coupons"
      />
    </>
  );
};
